import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ContractDetail from './ContractDetail';

export default function ContractsRoutes() {
  return (
    <Routes>
      <Route path="new" element={<ContractDetail isEdit isCreate />} />
      <Route path=":id" element={<ContractDetail />} />
      <Route path=":id/edit" element={<ContractDetail isEdit />} />
    </Routes>
  );
}
